import { useEffect, useRef } from 'react';
import { useHlsContext } from "../../context/Hls";
import { usePlaybackContext } from "../../context/Playback";
import { useResponsiveContext } from "../../context/Responsive";
import BannerWarning from "./BannerWarning";
import PopperWarning from "./PopperWarning";
import { jsx as _jsx } from "react/jsx-runtime";
var QualityWarning = function QualityWarning() {
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _usePlaybackContext = usePlaybackContext(),
    currentTime = _usePlaybackContext.currentTime,
    currentProgress = _usePlaybackContext.currentProgress;
  var _useHlsContext = useHlsContext(),
    currentQualityWarning = _useHlsContext.currentQualityWarning,
    hideQualityWarning = _useHlsContext.hideQualityWarning,
    withLowQualityWarning = _useHlsContext.withLowQualityWarning,
    withManualHighQualityWarning = _useHlsContext.withManualHighQualityWarning,
    realCurrentQualityValue = _useHlsContext.realCurrentQualityValue;
  var shouldRenderPopper = playerSize.matches.sm;
  var warningTimeout = useRef();
  var onDismiss = function onDismiss() {
    hideQualityWarning();
  };
  var onManualDismiss = function onManualDismiss() {
    var onWarningManuallyClosed = currentQualityWarning === 'low-quality' ? withLowQualityWarning === null || withLowQualityWarning === void 0 ? void 0 : withLowQualityWarning.onWarningManuallyClosed : withManualHighQualityWarning === null || withManualHighQualityWarning === void 0 ? void 0 : withManualHighQualityWarning.onWarningManuallyClosed;
    if (onWarningManuallyClosed) {
      onWarningManuallyClosed({
        currentTime: currentTime,
        currentProgress: currentProgress,
        quality: realCurrentQualityValue
      });
    }
    onDismiss();
  };
  useEffect(function () {
    if (currentQualityWarning) {
      if (warningTimeout.current) {
        clearTimeout(warningTimeout.current);
      }
      // Automatically dismiss after given seconds if required
      var currentQualityWarningConfig = currentQualityWarning === 'low-quality' ? withLowQualityWarning : withManualHighQualityWarning;
      var dismissAfterSeconds = shouldRenderPopper ? currentQualityWarningConfig === null || currentQualityWarningConfig === void 0 ? void 0 : currentQualityWarningConfig.dismissPopperAfterSeconds : currentQualityWarningConfig === null || currentQualityWarningConfig === void 0 ? void 0 : currentQualityWarningConfig.dismissBannerAfterSeconds;
      if (dismissAfterSeconds) {
        warningTimeout.current = window.setTimeout(function () {
          onDismiss();
        }, dismissAfterSeconds * 1000);
      }
    }
    return function () {
      if (warningTimeout.current) {
        clearTimeout(warningTimeout.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentQualityWarning, shouldRenderPopper]);
  if (shouldRenderPopper) {
    var isSm = !playerSize.matches.md;
    return /*#__PURE__*/_jsx(PopperWarning, {
      selector: isSm ? '.cp-settings-btn-tablet' : '.cp-settings-btn',
      isSm: isSm,
      onDismiss: onManualDismiss,
      currentQualityWarning: currentQualityWarning
    });
  }
  return /*#__PURE__*/_jsx(BannerWarning, {
    isXxs: !playerSize.matches.xs,
    currentQualityWarning: currentQualityWarning
  });
};
export default QualityWarning;